import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../shared/models/auth.service";
import { ApplicationRouteURL } from "../../shared/config";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CreditCardPaymentService } from "../models/credit-card-payment.service";

@Component({
  selector: "wego-creditcard-payment-success",
  template: require('../views/creditcard-payment-success.component.html'),
  providers: [CreditCardPaymentService]
})
export class CreditCardPaymentSuccessComponent implements OnInit {
  urlDefaultPage: any;
  transactionId: string;
  private sub: any;

  constructor(
    public authService: AuthService,
    public creditCardPaymentService: CreditCardPaymentService,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
  }

  public onSubmit() {
    let urlBookingOverview = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_OVERVIEW
    );
    this.router.navigate([urlBookingOverview]);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/creditcardpaymentpopup/components/creditcard-payment-success.component.ts